"use strict";

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.number.constructor");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.replace");

require("core-js/modules/es.string.split");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var isAcn = function isAcn(message) {
  return function (_ref) {
    var field = _ref.field;
    var value = field.value; // If ACN is false return undefined

    if (!value) {
      return true;
    } // Fail if any non digit value given except spaces


    if (!/^(?=.*\d)[\d ]+$/.test(value)) {
      return [false, message];
    }

    var acnWeights = [8, 7, 6, 5, 4, 3, 2, 1];
    var digits = value.replace(/[^\d]/g, '').split('').map(Number); // If inputted numbers is not equal to 9 return false

    if (digits.length !== 9) {
      return [false, message];
    }

    var addWeighted = function addWeighted(p, v, i) {
      return p + v * acnWeights[i];
    };

    var sum = digits.slice(0, 8).reduce(addWeighted, 0);
    var lastDigit = (10 - sum % 10) % 10;

    if (lastDigit === 10) {
      lastDigit = 0;
    }

    if (lastDigit === digits[8]) {
      return [true, message];
    }

    return [false, message];
  };
};

var _default = isAcn;
exports.default = _default;
//# sourceMappingURL=isAcn.js.map